<template>
	<div>
		<div class="integral integral-birth pad">
			<p class="explain_record">
				<img src="/static/line.png" alt="">
				<span>我的生日券</span>
			</p>
		</div>
		<ul class="order ovw mar_b" v-if="false">
			<li :class="dataType == ''?'on':''"><a href="javascript:;" @click="queryData('',1)"><span>全部</span></a><i></i></li>
			<li :class="dataType == '2'?'on':''"><a href="javascript:;" @click="queryData('2',1)"><span>待出库</span></a><i></i></li>
			<li :class="dataType == '4'?'on':''"><a href="javascript:;" @click="queryData('4',1)"><span>已出库</span></a><i></i></li>
		</ul>
		<ul class="record_list2">
			<li v-for="(item,index) in list" :key="index">
				<div class="order-no"><span><img src="/static/line.png" alt=""> 券号：{{item.cardID}}</span><span>{{item.status == 1 ? "未使用" : "已使用"}}</span></div>
				<div class="order-no">
					<span>密码：{{item.cardPwd}}</span>
					<span>过期日期：{{item.endDate.split('T')[0]}}</span>
				</div>
			</li>
		</ul>
		<div class="no-data" v-if="list.length == 0"></div>
	</div>
</template>

<script>
import {
  GiftOrder_Birth
} from "@/api/api.js"
export default {
  data () {
    return {
		dataType:'',
		list:[],
		page:1,
		size:20,
		isQuery:false
    }
  },
  methods:{
	  queryData(t,page){
		  let that = this;
		  if(that.isQuery){return;}

		  that.isQuery = true;
		  this.page = page; 
		  this.dataType = t;
		  if(this.page == 1){
			  this.list = [];
		  }

		  let query = {page:that.page,size:that.size,status:null};

		  GiftOrder_Birth(query,function(res){
			  that.list = that.list.concat(res.data);
			  that.isQuery = false;
		  })
	  },
	  detail(t){
		  let that = this;
		  that.$router.push('giftorderdetail?id=' + t.id);
	  }
  },
  created:function(){
	  let that = this;
	  this.queryData(this.dataType,1);
	  window.onscroll = () => {
        let bottomOfWindow = document.documentElement.offsetHeight - document.documentElement.scrollTop - window.innerHeight <= 20
        if (bottomOfWindow  && !that.isQuery) {
          that.queryData(this.dataType,this.page + 1);
        }
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.integral.integral-birth.pad {
    height: 100px;
    background-position: center bottom;
}
.integral .explain_record {
    margin-top: 40px;
}
.record_list2 li img {
    width: 3px;
    height: auto;
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/wechat/giftbirth.vue